import { convertDateResponse } from "@relode/core";
import { AddJobStep2Details } from "../../types/addJobStep2Details";
import { JobPendingStepTwoResponse } from "../controllers/jobs";
import { convertLocationResponse } from "./convertCommonResponses";

export const convertAddJobStep2DetailsResponse = (
    response: JobPendingStepTwoResponse
): AddJobStep2Details => {
    if (!response) return null;

    const step2Details = new AddJobStep2Details();
    step2Details.teamId = response.teamId;
    step2Details.location = convertLocationResponse(response.location);
    step2Details.normalizedLocation = convertLocationResponse(
        response.normalizedLocation
    );
    step2Details.quantity = response.quantity;
    step2Details.hoursPerWeek = response.hoursPerWeek;
    step2Details.contractDuration = response.contractDuration;
    step2Details.jobTypeId = response.jobTypeId;
    step2Details.jobName = response.jobName;
    step2Details.normalizedJobName = response.normalizedJobName;
    step2Details.jobSalaryInUSDollars = response.jobSalaryInUSDollars;
    step2Details.jobSalaryTypeId = response.jobSalaryTypeId;
    step2Details.contractStartDate = convertDateResponse(
        response.contractStartDate
    );
    step2Details.contractDurationTypeId = response.contractDurationTypeId;
    step2Details.jobConcurrencyToken = response.jobConcurrencyToken;

    return step2Details;
};
